/* eslint-disable max-len */
/* eslint-disable camelcase */

import { gql } from "@apollo/react-hooks";
import { CommandResult_UserModuleAccess, CommandResult_Void } from "../../helpers/types.graphql";
import { CommandResult } from "../fragment.graphql";

type TUserModuleAccessCreateFunctions = { create: CommandResult_UserModuleAccess };
export type TUserModuleAccessCreateMutations = { userModuleAccess: TUserModuleAccessCreateFunctions };
export const userModuleAccessCreate = () => gql`
  mutation userModuleAccessCreate($userModuleAccess: UserModuleAccessCreateInputType!) {
    userModuleAccess {
      create(userModuleAccess: $userModuleAccess) {
        ...COMMAND_RESULT
        result {
          id
          userId
          moduleId
        }
      }
    }
  }
  ${CommandResult("CommandResult_UserModuleAccess")}
`;

type TRevokeUserModuleAccessFunctions = { revokeUserModuleAccess: CommandResult_Void };
export type TRevokeUserModuleAccessMutations = { userModuleAccess: TRevokeUserModuleAccessFunctions };
export const revokeUserModuleAccess = () => gql`
  mutation revokeUserModuleAccess($id: ID!) {
    userModuleAccess {
      revokeUserModuleAccess(id: $id) {
        ...COMMAND_RESULT
      }
    }
  }
  ${CommandResult("CommandResult_Void")}
`;
